import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { Alert } from 'types/Alert';

export const addAlert = createActionCreator(
  'ALERT/CREATE',
  resolve => (title: string, message: string, isModal?: boolean) =>
    resolve({ title, message, isModal })
);

export const setStoreAlert = createActionCreator(
  'ALERT/CREATE_IN_STORE',
  resolve => (alert: Alert) => resolve(alert)
);

export const deleteStoreAlert = createActionCreator(
  'ALERT/DELETE_FROM_STORE',
  resolve => (id: string) => resolve(id)
);

export const emitAxiosError = createActionCreator(
  'ALERT/EMIT_AXIOS_ERROR',
  resolve => (url: string, status: string, text?: string) => resolve({ url, status, text })
);

const defaultAlert: Alert | null = null;
export const alert = createReducer(defaultAlert, handle => [
  handle(setStoreAlert, (_, { payload }) => payload),
  handle(deleteStoreAlert, (state, { payload: id }) => (state?.id === id ? null : state))
]);

export const getAlertMessage = (state: AppState): string => state.alert?.message;
export const getAlert = (state: AppState): Alert => state.alert;
